export var VideoPosition = /*#__PURE__*/ function(VideoPosition) {
    VideoPosition["PREROLL"] = "preroll";
    VideoPosition["MIDROLL"] = "midroll";
    VideoPosition["POSTROLL"] = "postroll";
    VideoPosition["STANDALONE"] = "standalone";
    return VideoPosition;
}({});
/**
 * Enum for sandboxing mode. FULL implies both that verification code has access
 * to the creative element and that OMSDK will provide a reference to that
 * creative element via video/slotElement in the context.
 */ export var AccessMode = /*#__PURE__*/ function(AccessMode) {
    AccessMode["FULL"] = "full";
    AccessMode["DOMAIN"] = "domain";
    AccessMode["LIMIT"] = "limited";
    return AccessMode;
}({});
export var ErrorType = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GENERIC"] = "generic";
    ErrorType["VIDEO"] = "video";
    ErrorType["MEDIA"] = "media";
    return ErrorType;
}({});
export var CreativeType = /*#__PURE__*/ function(CreativeType) {
    CreativeType["DEFINED_BY_JAVASCRIPT"] = "definedByJavaScript";
    CreativeType["HTML_DISPLAY"] = "htmlDisplay";
    CreativeType["NATIVE_DISPLAY"] = "nativeDisplay";
    CreativeType["VIDEO"] = "video";
    CreativeType["AUDIO"] = "audio";
    return CreativeType;
}({});
export var AdEventType = /*#__PURE__*/ function(AdEventType) {
    AdEventType["IMPRESSION"] = "impression";
    AdEventType["LOADED"] = "loaded";
    AdEventType["GEOMETRY_CHANGE"] = "geometryChange";
    AdEventType["SESSION_START"] = "sessionStart";
    AdEventType["SESSION_ERROR"] = "sessionError";
    AdEventType["SESSION_FINISH"] = "sessionFinish";
    AdEventType["MEDIA"] = "media";
    AdEventType["VIDEO"] = "video";
    AdEventType["START"] = "start";
    AdEventType["FIRST_QUARTILE"] = "firstQuartile";
    AdEventType["MIDPOINT"] = "midpoint";
    AdEventType["THIRD_QUARTILE"] = "thirdQuartile";
    AdEventType["COMPLETE"] = "complete";
    AdEventType["PAUSE"] = "pause";
    AdEventType["RESUME"] = "resume";
    AdEventType["BUFFER_START"] = "bufferStart";
    AdEventType["BUFFER_FINISH"] = "bufferFinish";
    AdEventType["SKIPPED"] = "skipped";
    AdEventType["VOLUME_CHANGE"] = "volumeChange";
    AdEventType["PLAYER_STATE_CHANGE"] = "playerStateChange";
    AdEventType["AD_USER_INTERACTION"] = "adUserInteraction";
    AdEventType["STATE_CHANGE"] = "stateChange";
    return AdEventType;
}({});
export var ImpressionType = /*#__PURE__*/ function(ImpressionType) {
    ImpressionType["IMPRESSION"] = "impression";
    ImpressionType["LOADED"] = "loaded";
    ImpressionType["GEOMETRY_CHANGE"] = "geometryChange";
    ImpressionType["SESSION_START"] = "sessionStart";
    ImpressionType["SESSION_ERROR"] = "sessionError";
    ImpressionType["SESSION_FINISH"] = "sessionFinish";
    ImpressionType["MEDIA"] = "media";
    ImpressionType["VIDEO"] = "video";
    ImpressionType["START"] = "start";
    ImpressionType["FIRST_QUARTILE"] = "firstQuartile";
    ImpressionType["MIDPOINT"] = "midpoint";
    ImpressionType["THIRD_QUARTILE"] = "thirdQuartile";
    ImpressionType["COMPLETE"] = "complete";
    ImpressionType["PAUSE"] = "pause";
    ImpressionType["RESUME"] = "resume";
    ImpressionType["BUFFER_START"] = "bufferStart";
    ImpressionType["BUFFER_FINISH"] = "bufferFinish";
    ImpressionType["SKIPPED"] = "skipped";
    ImpressionType["VOLUME_CHANGE"] = "volumeChange";
    ImpressionType["PLAYER_STATE_CHANGE"] = "playerStateChange";
    ImpressionType["AD_USER_INTERACTION"] = "adUserInteraction";
    ImpressionType["STATE_CHANGE"] = "stateChange";
    ImpressionType["BEGIN_TO_RENDER"] = "beginToRender";
    return ImpressionType;
}({});
export var InteractionType = /*#__PURE__*/ function(InteractionType) {
    InteractionType["CLICK"] = "click";
    InteractionType["INVITATION_ACCEPT"] = "invitationAccept";
    return InteractionType;
}({});
export var VideoPlayerState = /*#__PURE__*/ function(VideoPlayerState) {
    VideoPlayerState["MINIMIZED"] = "minimized";
    VideoPlayerState["COLLAPSED"] = "collapsed";
    VideoPlayerState["NORMAL"] = "normal";
    VideoPlayerState["EXPANDED"] = "expanded";
    VideoPlayerState["FULLSCREEN"] = "fullscreen";
    return VideoPlayerState;
}({});
export var Environment = /*#__PURE__*/ function(Environment) {
    Environment["APP"] = "app";
    Environment["WEB"] = "web";
    return Environment;
}({});
export var MediaType = /*#__PURE__*/ function(MediaType) {
    MediaType["DISPLAY"] = "display";
    MediaType["VIDEO"] = "video";
    return MediaType;
}({});
/**
 * Enum for reasons for viewability calculation results.
 */ export var Reason = /*#__PURE__*/ function(Reason) {
    Reason["NOT_FOUND"] = "notFound";
    Reason["HIDDEN"] = "hidden";
    Reason["BACKGROUNDED"] = "backgrounded";
    Reason["VIEWPORT"] = "viewport";
    Reason["OBSTRUCTED"] = "obstructed";
    Reason["CLIPPED"] = "clipped";
    Reason["UNMEASURABLE"] = "unmeasurable";
    Reason["NO_WINDOW_FOCUS"] = "noWindowFocus";
    return Reason;
}({});

//# sourceMappingURL=open-measurement-types.js.map